export default __webpack_public_path__ + "img/user.faceb2adae42332dfe50769971aff067.png";